let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("h2MrD"), load("bYT2S"), load("hPzOn"), load("cM9em"), load("fr9NE"), load("1IWsG")]).then(() => parcelRequire('97LNn'));